import React from 'react';
import PropTypes from "prop-types";
import OutputLine from "./OutputLine";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
	lines: PropTypes.arrayOf(PropTypes.shape({
		indent: PropTypes.number.isRequired,
		output: PropTypes.string.isRequired,
	})).isRequired,
};
const defaultProps = {
};

const OutputLines = ({baseIndent, lines}) => (
	lines.map((line, i) => <OutputLine key={i} indent={baseIndent + line.indent}>{line.output}</OutputLine>)
);

OutputLines.propTypes = propTypes;
OutputLines.defaultProps = defaultProps;

export default OutputLines;
